import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig, waitForElement } from './utils';
import { TourService } from './tour.service';

export function getWelcomeTourSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);

    return [
      {
        id: 'welcome-step-01',
        title: 'Welcome to our website',
        text: "We're pleased to have you here. Feel free to explore our services and discover how we can support your goals.",
        classes: 'shepherd-custom shepherd-custom-centered',
        buttons: [
          {
            text: 'See later',
            classes: 'Button--white',
            action() {
              this.cancel();
            }
          },
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'welcome-step-02',
        title: 'Visit our Help Center',
        text: 'On this page you can access all our Guided Tours, download useful documents and watch videos explaining how our site works.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#WelcomeStep2',
          on: 'bottom-end' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#WelcomeStep2').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'See later',
            classes: 'Button--white',
            action() {
              this.cancel();
            }
          },
          {
            text: 'Next',
            action() {
              router.navigate(['/site/help']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Welcome-step-mobile-03',
        title: 'Our Guided Tours',
        text: "Don't hesitate to launch all our Guided Tours to discover all the features of our site.",
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#WelcomeStep3',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Finish',
            action() {
              const tourService = injector.get(TourService);
              tourService.markTourAsViewed('welcome-tour').subscribe();
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ],
        ...commonConfig,
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#WelcomeStep3').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        }
      }
    ];
  });
}